var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-ons-page',[_c('div',{staticClass:"-translate-x-1/2 -translate-y-1/2 absolute left-1/2 top-1/2 transform"},[_vm._v(" Allastarsea ")])])}
var staticRenderFns = []

export { render, staticRenderFns }